import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=21835d46&scoped=true&"
import script from "./InputSwitch.vue?vue&type=script&lang=js&"
export * from "./InputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=21835d46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21835d46",
  null
  
)

export default component.exports